/** URL filter key for "DUNS not on an active SPA" on the staged and pending pages. */
export const DUNS_NOT_ON_SPA_FILTER_KEY = 'duns_not_on_spa';

/**
 * Whether the "DUNS not on SPA" filter is offered: only once the supplier
 * filter is narrowed to suppliers that have the SPA DUNS check (Schneider
 * today, per the filter options' `hasSpaDunsCheck`). The SPA lookup runs per
 * claim, so it is never offered across every supplier at once.
 */
export function spaDunsFilterApplies(
  selectedSupplierIds: readonly string[] | undefined,
  suppliers: readonly { id: string; hasSpaDunsCheck?: boolean }[] | undefined,
): boolean {
  if (!selectedSupplierIds || selectedSupplierIds.length === 0) return false;
  const checked = new Set<string>();
  for (const supplier of suppliers ?? []) {
    if (supplier.hasSpaDunsCheck) checked.add(supplier.id);
  }
  return selectedSupplierIds.every((id) => checked.has(id));
}

/** The `dunsNotOnSpa` list input: on only when toggled and still offered. */
export function dunsNotOnSpaInput(
  filters: Record<string, string[] | undefined>,
  suppliers: readonly { id: string; hasSpaDunsCheck?: boolean }[] | undefined,
): true | undefined {
  return filters[DUNS_NOT_ON_SPA_FILTER_KEY]?.[0] === 'true' &&
    spaDunsFilterApplies(filters.trading_partner, suppliers)
    ? true
    : undefined;
}
